import React from 'react';
import { IconProps } from '../../DefaultIcon';

export function CompaniesIcon({ className }: IconProps) {
  return (
    <svg
      width="82"
      height="82"
      viewBox="0 0 82 82"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_1203_1295)">
        <path
          d="M78.6573 0H29.3137C27.4814 0 25.9961 1.49211 25.9961 3.33273V71.2308C25.9961 73.0714 27.4814 74.5635 29.3137 74.5635H78.6573C80.4896 74.5635 81.975 73.0714 81.975 71.2308V3.33273C81.975 1.49211 80.4896 0 78.6573 0Z"
          fill="#EAEDF8"
        />
        <path
          d="M58.479 52.8262H49.5165C48.8975 52.8262 48.4023 52.3288 48.4023 51.707V47.2054C48.4023 46.5836 48.8975 46.0862 49.5165 46.0862H58.479C59.098 46.0862 59.5932 46.5836 59.5932 47.2054V51.707C59.5932 52.3288 59.098 52.8262 58.479 52.8262Z"
          fill="#DDE0E7"
        />
        <path
          d="M73.8794 52.8262H64.9169C64.2979 52.8262 63.8027 52.3288 63.8027 51.707V47.2054C63.8027 46.5836 64.2979 46.0862 64.9169 46.0862H73.8794C74.4984 46.0862 74.9936 46.5836 74.9936 47.2054V51.707C74.9936 52.3288 74.4984 52.8262 73.8794 52.8262Z"
          fill="#00416B"
        />
        <path
          d="M43.0796 52.8262H34.1171C33.4981 52.8262 33.0029 52.3288 33.0029 51.707V47.2054C33.0029 46.5836 33.4981 46.0862 34.1171 46.0862H43.0796C43.6986 46.0862 44.1938 46.5836 44.1938 47.2054V51.707C44.1938 52.3288 43.6986 52.8262 43.0796 52.8262Z"
          fill="#00416B"
        />
        <path
          d="M58.479 39.744H49.5165C48.8975 39.744 48.4023 39.2465 48.4023 38.6248V34.1231C48.4023 33.5013 48.8975 33.0039 49.5165 33.0039H58.479C59.098 33.0039 59.5932 33.5013 59.5932 34.1231V38.6248C59.5932 39.2465 59.098 39.744 58.479 39.744Z"
          fill="#00416B"
        />
        <path
          d="M73.8794 39.744H64.9169C64.2979 39.744 63.8027 39.2465 63.8027 38.6248V34.1231C63.8027 33.5013 64.2979 33.0039 64.9169 33.0039H73.8794C74.4984 33.0039 74.9936 33.5013 74.9936 34.1231V38.6248C74.9936 39.2465 74.4984 39.744 73.8794 39.744Z"
          fill="#00C4B3"
        />
        <path
          d="M43.0796 39.744H34.1171C33.4981 39.744 33.0029 39.2465 33.0029 38.6248V34.1231C33.0029 33.5013 33.4981 33.0039 34.1171 33.0039H43.0796C43.6986 33.0039 44.1938 33.5013 44.1938 34.1231V38.6248C44.1938 39.2465 43.6986 39.744 43.0796 39.744Z"
          fill="#00C4B3"
        />
        <path
          d="M58.479 26.3883H49.5165C48.8975 26.3883 48.4023 25.8908 48.4023 25.2691V20.7674C48.4023 20.1456 48.8975 19.6482 49.5165 19.6482H58.479C59.098 19.6482 59.5932 20.1456 59.5932 20.7674V25.2691C59.5932 25.8908 59.098 26.3883 58.479 26.3883Z"
          fill="#00416B"
        />
        <path
          d="M73.8794 26.3883H64.9169C64.2979 26.3883 63.8027 25.8908 63.8027 25.2691V20.7674C63.8027 20.1456 64.2979 19.6482 64.9169 19.6482H73.8794C74.4984 19.6482 74.9936 20.1456 74.9936 20.7674V25.2691C74.9936 25.8908 74.4984 26.3883 73.8794 26.3883Z"
          fill="#DDE0E7"
        />
        <path
          d="M43.0796 26.3883H34.1171C33.4981 26.3883 33.0029 25.8908 33.0029 25.2691V20.7674C33.0029 20.1456 33.4981 19.6482 34.1171 19.6482H43.0796C43.6986 19.6482 44.1938 20.1456 44.1938 20.7674V25.2691C44.1938 25.8908 43.6986 26.3883 43.0796 26.3883Z"
          fill="#DDE0E7"
        />
        <path
          d="M58.479 13.0325H49.5165C48.8975 13.0325 48.4023 12.5351 48.4023 11.9133V7.41168C48.4023 6.7899 48.8975 6.29248 49.5165 6.29248H58.479C59.098 6.29248 59.5932 6.7899 59.5932 7.41168V11.9133C59.5932 12.5351 59.098 13.0325 58.479 13.0325Z"
          fill="#DDE0E7"
        />
        <path
          d="M73.8794 13.0325H64.9169C64.2979 13.0325 63.8027 12.5351 63.8027 11.9133V7.41168C63.8027 6.7899 64.2979 6.29248 64.9169 6.29248H73.8794C74.4984 6.29248 74.9936 6.7899 74.9936 7.41168V11.9133C74.9936 12.5351 74.4984 13.0325 73.8794 13.0325Z"
          fill="#00C4B3"
        />
        <path
          d="M43.0796 13.0325H34.1171C33.4981 13.0325 33.0029 12.5351 33.0029 11.9133V7.41168C33.0029 6.7899 33.4981 6.29248 34.1171 6.29248H43.0796C43.6986 6.29248 44.1938 6.7899 44.1938 7.41168V11.9133C44.1938 12.5351 43.6986 13.0325 43.0796 13.0325Z"
          fill="#00416B"
        />
        <path
          d="M52.7111 74.5636H28.5468C27.1356 74.5636 26.0215 73.3947 26.0215 71.9522V71.7781H55.4098C55.4098 73.3201 54.1966 74.5636 52.7111 74.5636Z"
          fill="#DDE0E7"
        />
        <path
          d="M79.2765 74.5636H55.1123C53.701 74.5636 52.5869 73.3947 52.5869 71.9522V71.7781H81.9752C81.9752 73.3201 80.762 74.5636 79.2765 74.5636Z"
          fill="#DDE0E7"
        />
        <path
          d="M57.0934 59.0439H50.9286C50.0868 59.0439 49.3936 59.7403 49.3936 60.586V74.5386H58.6532V60.586C58.6532 59.7403 57.96 59.0439 57.1182 59.0439H57.0934Z"
          fill="#00416B"
        />
        <path
          d="M74.3251 57.5518H64.4712C64.102 57.5518 63.8027 57.8524 63.8027 58.2233V67.1271C63.8027 67.498 64.102 67.7987 64.4712 67.7987H74.3251C74.6943 67.7987 74.9936 67.498 74.9936 67.1271V58.2233C74.9936 57.8524 74.6943 57.5518 74.3251 57.5518Z"
          fill="#DDE0E7"
        />
        <path
          d="M43.5253 57.5518H33.6714C33.3022 57.5518 33.0029 57.8524 33.0029 58.2233V67.1271C33.0029 67.498 33.3022 67.7987 33.6714 67.7987H43.5253C43.8945 67.7987 44.1938 67.498 44.1938 67.1271V58.2233C44.1938 57.8524 43.8945 57.5518 43.5253 57.5518Z"
          fill="#DDE0E7"
        />
        <path
          d="M32.4588 82H7.15565C5.71966 82 4.53125 80.8311 4.53125 79.3637V52.105H35.3555V79.0652C35.3555 80.6819 34.0681 81.9752 32.4588 81.9752"
          fill="#EAEDF8"
        />
        <path
          d="M32.5331 82H7.1804C5.71966 82 4.53125 80.7813 4.53125 79.2642V79.0901H35.3555C35.3555 80.7067 34.0928 82 32.5331 82Z"
          fill="#DDE0E7"
        />
        <path
          d="M31.9887 63.6204H21.095C20.6984 63.6204 20.377 63.9433 20.377 64.3416V74.1906C20.377 74.5889 20.6984 74.9118 21.095 74.9118H31.9887C32.3852 74.9118 32.7067 74.5889 32.7067 74.1906V64.3416C32.7067 63.9433 32.3852 63.6204 31.9887 63.6204Z"
          fill="#DDE0E7"
        />
        <path
          d="M4.70445 60.4119H3.2437C1.43633 60.4119 -0.0244141 58.9445 -0.0244141 57.1289H7.94781C7.94781 58.9445 6.48706 60.4119 4.67969 60.4119"
          fill="#00C4B3"
        />
        <path
          d="M12.7015 60.4119H11.2408C9.4334 60.4119 7.97266 58.9445 7.97266 57.1289H15.9449C15.9449 58.9445 14.4841 60.4119 12.6768 60.4119"
          fill="#00416B"
        />
        <path
          d="M20.6732 60.4119H19.2125C17.4051 60.4119 15.9443 58.9445 15.9443 57.1289H23.9166C23.9166 58.9445 22.4558 60.4119 20.6484 60.4119"
          fill="#00C4B3"
        />
        <path
          d="M28.6459 60.4119H27.1851C25.3777 60.4119 23.917 58.9445 23.917 57.1289H31.8892C31.8892 58.9445 30.4285 60.4119 28.6211 60.4119"
          fill="#00416B"
        />
        <path
          d="M36.6429 60.4119H35.1822C33.3748 60.4119 31.9141 58.9445 31.9141 57.1289H39.8863C39.8863 58.9445 38.4255 60.4119 36.6182 60.4119"
          fill="#00C4B3"
        />
        <path
          d="M35.355 52.1299H29.5615L31.9136 57.2285H39.8858L35.355 52.1299Z"
          fill="#00C4B3"
        />
        <path
          d="M10.3247 52.1299L7.97266 57.2285H15.9696L16.9847 52.1299H10.3247Z"
          fill="#00416B"
        />
        <path
          d="M22.9023 52.1299L23.9422 57.2285H31.9144L29.5624 52.1299H22.9023Z"
          fill="#00416B"
        />
        <path
          d="M4.5308 52.1299L0 57.2285H7.97222L10.3243 52.1299H4.5308Z"
          fill="#00C4B3"
        />
        <path
          d="M16.9848 52.1299L15.9697 57.2285H23.9419L22.9021 52.1299H16.9848Z"
          fill="#00C4B3"
        />
        <path
          d="M15.722 65.7593H9.23528C8.34397 65.7593 7.62598 66.4805 7.62598 67.3759V82.025H17.3313V67.3759C17.3313 66.4805 16.6133 65.7593 15.722 65.7593Z"
          fill="#00416B"
        />
        <path
          d="M7.37847 49.22H32.7064C34.1671 49.22 35.3555 50.4387 35.3555 51.9558V52.1299H4.53125C4.53125 50.5133 5.79393 49.22 7.35371 49.22"
          fill="#DDE0E7"
        />
      </g>
      <defs>
        <clipPath id="clip0_1203_1295">
          <rect width="82" height="82" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
